import Cookie from '/app/utils/cookie';
import { config } from '/app/config';

export default requester => {
    return {
        /**
         * Track actions
         *
         * @param {object} params
         */
        track (event, properties = {}) {
            return requester.post('/nerves/trait', {
                fingerprint: Cookie.get('fingerprint'),
                type: 'track',
                event: event,
                context: {
                  version: config.app.version,
                  page: {
                    path: location.pathname,
                    referrer: document.referrer,
                    origin: location.href
                  }
                },
                properties,
                sent_at: new Date()
            });
        }
    };
}
